import { OrganizersTable } from '../components/OrganizersTable';

export const Organizers = () => {
  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-xl font-semibold text-gray-900">Organizers</h1>
      <OrganizersTable />
    </div>
  );
};
